<svelte:options customElement="clw-icon-info" />

<script lang="ts">
    export let fillColor;
</script>

<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 18">
    <g clip-path="url(#a)">
        <path
            fill={fillColor || 'currentColor'}
            fill-rule="evenodd"
            d="M8.5 17.25c4.5563 0 8.25-3.6937 8.25-8.25 0-4.55635-3.6937-8.25-8.25-8.25C3.94365.75.25 4.44365.25 9c0 4.5563 3.69365 8.25 8.25 8.25Zm-.88572-6.5179h1.55786c.00838-.3131.04398-.5815.10679-.80508.06282-.22363.18846-.43912.37691-.64647.22614-.25209.43976-.49401.64076-.72576.201-.23582.3643-.48994.4899-.76235.1257-.27241.1885-.58548.1885-.93921 0-.5123-.0984-.94532-.2952-1.29905-.1969-.35779-.4795-.62817-.84807-.81114-.36434-.18703-.80406-.28054-1.31917-.28054-.46484 0-.88572.08945-1.26262.26835-.37272.17483-.66796.44521-.88573.81114-.21776.36592-.33083.83146-.33921 1.39662h1.77145c0-.24395.03769-.44115.11307-.59158.07538-.15044.16751-.26225.27639-.33544.10889-.07318.21777-.10978.32665-.10978.15495 0 .28268.03863.38319.11588.10051.07725.17589.1911.22614.34153.05444.15044.08166.3395.08166.56719 0 .19923-.03559.38016-.10679.54279-.07119.15857-.16751.31511-.28896.46961-.11725.15044-.24917.30901-.39574.47571-.20102.20736-.36016.41878-.47742.63427-.11725.21549-.20101.45944-.25126.73186-.04607.26835-.0691.58545-.0691.95145Zm.10679 1.2014c-.17589.1789-.26384.4025-.26384.6709 0 .2602.08795.4818.26384.6648.17588.1789.4104.2683.70355.2683s.52557-.0894.69727-.2683c.1717-.183.25755-.4046.25755-.6648 0-.2684-.08585-.492-.25755-.6709-.1717-.1789-.40412-.2683-.69727-.2683-.29315 0-.52767.0894-.70355.2683Z"
            clip-rule="evenodd"
        />
    </g>
    <defs>
        <clipPath id="a">
            <path fill="transparent" d="M.25.75h16.5v16.5H.25z" />
        </clipPath>
    </defs>
</svg>
